import type * as React from 'react';

/**
 * Inline safe-area padding for full-screen mobile overlays.
 *
 * Returns CSS properties that respect the device's safe-area insets
 * (notch, Dynamic Island, home indicator). Works regardless of whether
 * the consumer's build pipeline scans this package for Tailwind classes.
 */
export function safeAreaPadding(options: { trackKeyboard?: boolean } = {}): React.CSSProperties {
  const { trackKeyboard = false } = options;
  return {
    paddingTop: 'env(safe-area-inset-top)',
    paddingLeft: 'env(safe-area-inset-left)',
    paddingRight: 'env(safe-area-inset-right)',
    paddingBottom: trackKeyboard
      ? 'max(env(safe-area-inset-bottom), var(--keyboard-height, 0px))'
      : 'env(safe-area-inset-bottom)',
  };
}
